import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const profileItemDefaultVariants = {
  "orientation": "horizontal"
}
const profileItemCompoundVariants = []

const profileItemSlotNames = [
  [
    "root",
    "profileItem__root"
  ],
  [
    "info",
    "profileItem__info"
  ]
]
const profileItemSlotFns = /* @__PURE__ */ profileItemSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, profileItemDefaultVariants, getSlotCompoundVariant(profileItemCompoundVariants, slotName))])

const profileItemFn = memo((props = {}) => {
  return Object.fromEntries(profileItemSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const profileItemVariantKeys = [
  "orientation"
]
const getVariantProps = (variants) => ({ ...profileItemDefaultVariants, ...compact(variants) })

export const profileItem = /* @__PURE__ */ Object.assign(profileItemFn, {
  __recipe__: false,
  __name__: 'profileItem',
  raw: (props) => props,
  variantKeys: profileItemVariantKeys,
  variantMap: {
  "orientation": [
    "horizontal",
    "vertical"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, profileItemVariantKeys)
  },
  getVariantProps
})